// extracted by mini-css-extract-plugin
export default {"image":"background__image__jwcq3","color":"background__color__nMchq","video":"background__video__clLMv","videoEnabled":"background__videoEnabled__SVa23"};